import React from "react";
import SummaryHeader from "./SummaryHeader";
import EventsList from "./EventsList";
import EventMatchDetail from "./EventMatchDetail";
import MetaAdsReconnectBanner from "./MetaAdsReconnectBanner";
import useMetaSocialAds from "../hooks/useMetaSocialAds";

const MetaSocialAdsLayout = ({
  team,
  csrfToken,
  summary: initialSummary,
  events: initialEvents,
  hasMetaAdsAccess,
  connectionStatus: initialConnectionStatus,
  migrated,
  integrationDetailsPath,
}) => {
  const {
    events,
    summary,
    selectedEventId,
    selectedEvent,
    matches,
    matchesLoading,
    sortBy,
    setSortBy,
    sortOptions,
    handleSelectEvent,
    handleCreateMatch,
    handleRemoveMatch,
    handleResync,
    syncStatus,
    connectionStatus,
  } = useMetaSocialAds({ teamId: team.id, initialEvents, initialSummary, initialConnectionStatus });

  if (!hasMetaAdsAccess) {
    return (
      <div className="meta-social-ads">
        <div className="meta-social-ads__header">
          <h1 className="meta-social-ads__title">Meta Social Ads</h1>
        </div>
        <div className="meta-social-ads__no-access">
          <p>Connect your Meta Ads account to view ad performance by event.</p>
          <a href={integrationDetailsPath} className="btn btn-setlist-primary">
            Go to Integrations
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className="meta-social-ads">
      {connectionStatus === "needs_reconnection" && (
        <MetaAdsReconnectBanner csrfToken={csrfToken} />
      )}
      <SummaryHeader summary={summary} onResync={migrated ? null : handleResync} syncStatus={syncStatus} />
      <div className="meta-social-ads__split-pane">
        <EventsList
          events={events}
          selectedEventId={selectedEventId}
          onSelectEvent={handleSelectEvent}
          sortBy={sortBy}
          onSortChange={setSortBy}
          sortOptions={sortOptions}
        />
        <EventMatchDetail
          event={selectedEvent}
          matches={matches}
          loading={matchesLoading}
          teamId={team.id}
          onRemoveMatch={handleRemoveMatch}
          onCreateMatch={handleCreateMatch}
        />
      </div>
    </div>
  );
};

export default MetaSocialAdsLayout;
